import React from "react";

export const RightIconWhite = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0.173828L6.59 1.58383L12.17 7.17383H0V9.17383H12.17L6.59 14.7638L8 16.1738L16 8.17383L8 0.173828Z"
      fill="white"
    />
  </svg>
);
export const RightIconPrimary = () => (
  <svg
    width="25"
    height="26"
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 0.810547L10.3262 2.9843L18.9287 11.6022H0.166626V14.6855H18.9287L10.3262 23.3035L12.5 25.4772L24.8333 13.1439L12.5 0.810547Z"
      fill="#F68C3D"
    />
  </svg>
);
export const Locations = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.70704 1.20294C8.51951 1.01547 8.26521 0.910156 8.00004 0.910156C7.73488 0.910156 7.48057 1.01547 7.29304 1.20294L0.293041 8.20294C0.110883 8.39154 0.0100885 8.64415 0.0123669 8.90634C0.0146453 9.16854 0.119814 9.41935 0.305222 9.60476C0.490631 9.79017 0.741443 9.89534 1.00364 9.89762C1.26584 9.89989 1.51844 9.7991 1.70704 9.61694L2.00004 9.32394V15.9099C2.00004 16.1752 2.1054 16.4295 2.29293 16.6171C2.48047 16.8046 2.73482 16.9099 3.00004 16.9099H5.00004C5.26526 16.9099 5.51961 16.8046 5.70715 16.6171C5.89468 16.4295 6.00004 16.1752 6.00004 15.9099V13.9099C6.00004 13.6447 6.1054 13.3904 6.29293 13.2028C6.48047 13.0153 6.73482 12.9099 7.00004 12.9099H9.00004C9.26526 12.9099 9.51961 13.0153 9.70715 13.2028C9.89468 13.3904 10 13.6447 10 13.9099V15.9099C10 16.1752 10.1054 16.4295 10.2929 16.6171C10.4805 16.8046 10.7348 16.9099 11 16.9099H13C13.2653 16.9099 13.5196 16.8046 13.7071 16.6171C13.8947 16.4295 14 16.1752 14 15.9099V9.32394L14.293 9.61694C14.4816 9.7991 14.7342 9.89989 14.9964 9.89762C15.2586 9.89534 15.5095 9.79017 15.6949 9.60476C15.8803 9.41935 15.9854 9.16854 15.9877 8.90634C15.99 8.64415 15.8892 8.39154 15.707 8.20294L8.70704 1.20294Z"
      fill="white"
    />
  </svg>
);
export const Analytics = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1677_3051)">
      <path
        d="M0.555623 13.7051H2.77771C3.08451 13.7051 3.33333 13.9537 3.33333 14.2605V19.8161C3.33333 20.1229 3.08451 20.3717 2.77771 20.3717H0.555623C0.24882 20.3717 0 20.1229 0 19.8161V14.2605C0 13.9537 0.24882 13.7051 0.555623 13.7051Z"
        fill="white"
      />
      <path
        d="M6.11108 9.26074H8.33337C8.64018 9.26074 8.889 9.50956 8.889 9.81637V19.8164C8.889 20.1232 8.64018 20.372 8.33337 20.372H6.11108C5.80428 20.372 5.55566 20.1232 5.55566 19.8164V9.81637C5.55566 9.50956 5.80428 9.26074 6.11108 9.26074Z"
        fill="white"
      />
      <path
        d="M11.6667 11.4834H13.889C14.1958 11.4834 14.4444 11.7322 14.4444 12.039V19.8167C14.4444 20.1235 14.1958 20.3724 13.889 20.3724H11.6667C11.3599 20.3724 11.1111 20.1235 11.1111 19.8167V12.039C11.1111 11.7322 11.3599 11.4834 11.6667 11.4834Z"
        fill="white"
      />
      <path
        d="M17.2222 8.14941H19.4443C19.7511 8.14941 20 8.39823 20 8.70504V19.8161C20 20.1229 19.7511 20.3717 19.4443 20.3717H17.2222C16.9154 20.3717 16.6666 20.1229 16.6666 19.8161V8.70504C16.6666 8.39823 16.9154 8.14941 17.2222 8.14941Z"
        fill="white"
      />
      <path
        d="M18.3333 1.4834C17.4133 1.48442 16.6677 2.23006 16.6667 3.15007C16.6689 3.33154 16.701 3.51139 16.7619 3.68229L13.9807 5.33553C13.6157 4.94836 13.0865 4.76078 12.5592 4.83138C12.0317 4.90198 11.5706 5.22221 11.3202 5.69177L8.86719 4.47677C8.87919 4.40535 8.88631 4.33333 8.88896 4.26111C8.89018 3.58647 8.4847 2.97774 7.86173 2.71875C7.23877 2.45996 6.5212 2.60217 6.04411 3.07906C5.56681 3.55595 5.42419 4.27332 5.68278 4.89648L2.50081 7.27116C2.24854 7.12081 1.96045 7.04065 1.66667 7.03902C0.746256 7.03902 0 7.78508 0 8.70569C0 9.6261 0.746256 10.3724 1.66667 10.3724C2.58708 10.3724 3.33333 9.6261 3.33333 8.70569C3.33191 8.50509 3.29407 8.30672 3.22164 8.11975L6.43534 5.72127C7.06401 6.07182 7.8481 5.96908 8.36507 5.46818L11.1546 6.84981C11.3405 7.67806 12.12 8.23389 12.9637 8.13989C13.8074 8.0459 14.4454 7.3324 14.4444 6.4834C14.4444 6.44108 14.435 6.4012 14.432 6.3597L17.4569 4.5614C17.7191 4.72721 18.0229 4.81571 18.3333 4.81673C19.2537 4.81673 20 4.07048 20 3.15007C20 2.22965 19.2537 1.4834 18.3333 1.4834Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1677_3051">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.910156)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const Deals = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1677_3065)">
      <path
        d="M18.6701 11.1693C18.5897 11.0046 18.5897 10.8158 18.6701 10.6512L19.4161 9.12522C19.8314 8.27558 19.5023 7.26289 18.6669 6.81965L17.1666 6.02356C17.0047 5.9377 16.8937 5.78489 16.862 5.60446L16.5686 3.93146C16.4052 2.99998 15.5436 2.37405 14.6074 2.50651L12.9256 2.7444C12.7441 2.77002 12.5646 2.71166 12.4329 2.58428L11.2122 1.40335C10.5325 0.745777 9.46762 0.745738 8.78793 1.40335L7.56716 2.5844C7.43544 2.71182 7.25595 2.77006 7.07447 2.74452L5.39272 2.50663C4.4562 2.37409 3.59488 3.0001 3.43148 3.93158L3.13805 5.6045C3.10637 5.78497 2.99539 5.93774 2.83356 6.02364L1.33317 6.81973C0.497788 7.26293 0.168727 8.27569 0.584037 9.12534L1.32993 10.6513C1.4104 10.8159 1.4104 11.0047 1.32993 11.1693L0.583998 12.6953C0.168688 13.5449 0.497749 14.5576 1.33313 15.0008L2.83352 15.7969C2.99539 15.8828 3.10637 16.0356 3.13805 16.216L3.43148 17.889C3.58023 18.737 4.30734 19.3317 5.14299 19.3316C5.2253 19.3316 5.30881 19.3258 5.39276 19.3139L7.07451 19.0761C7.25587 19.0503 7.43548 19.1088 7.5672 19.2362L8.78793 20.4171C9.12785 20.7459 9.56387 20.9103 10 20.9103C10.4361 20.9102 10.8724 20.7459 11.2121 20.4171L12.4329 19.2362C12.5646 19.1088 12.7442 19.0506 12.9256 19.0761L14.6074 19.3139C15.544 19.4464 16.4052 18.8205 16.5686 17.889L16.8621 16.2161C16.8937 16.0356 17.0047 15.8828 17.1666 15.7969L18.6669 15.0008C19.5023 14.5576 19.8314 13.5449 19.4161 12.6952L18.6701 11.1693ZM7.69298 5.71942C8.85907 5.71942 9.80777 6.66813 9.80777 7.83421C9.80777 9.0003 8.85907 9.94901 7.69298 9.94901C6.52689 9.94901 5.57819 9.0003 5.57819 7.83421C5.57819 6.66813 6.52689 5.71942 7.69298 5.71942ZM6.60142 15.1244C6.48881 15.2371 6.34119 15.2934 6.19361 15.2934C6.04604 15.2934 5.89838 15.2371 5.7858 15.1244C5.56057 14.8992 5.56057 14.534 5.7858 14.3088L13.3986 6.69598C13.6238 6.47074 13.989 6.47074 14.2143 6.69598C14.4395 6.92121 14.4395 7.2864 14.2143 7.51164L6.60142 15.1244ZM12.307 16.1011C11.1409 16.1011 10.1922 15.1524 10.1922 13.9863C10.1922 12.8202 11.1409 11.8715 12.307 11.8715C13.4731 11.8715 14.4218 12.8202 14.4218 13.9863C14.4218 15.1524 13.4731 16.1011 12.307 16.1011Z"
        fill="white"
      />
      <path
        d="M12.307 13.0254C11.777 13.0254 11.3457 13.4566 11.3457 13.9866C11.3457 14.5167 11.7769 14.9479 12.307 14.9479C12.837 14.9479 13.2682 14.5167 13.2682 13.9866C13.2682 13.4566 12.837 13.0254 12.307 13.0254Z"
        fill="white"
      />
      <path
        d="M7.69293 6.87305C7.1629 6.87305 6.73169 7.30426 6.73169 7.83429C6.73169 8.36433 7.1629 8.79557 7.69293 8.79557C8.22297 8.79557 8.65422 8.36437 8.65422 7.83429C8.65418 7.30429 8.22297 6.87305 7.69293 6.87305Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1677_3065">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.910156)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const Advertising = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7916 1.07569C13.7916 0.711522 13.5691 0.384022 13.23 0.249856C12.8908 0.115689 12.5041 0.202356 12.255 0.468189C10.67 2.15902 8.45579 3.11819 6.13913 3.11819C5.13329 3.11819 4.07913 3.11819 3.16663 3.11819C2.33746 3.11819 1.54329 3.44736 0.956626 4.03319C0.370793 4.61986 0.041626 5.41402 0.041626 6.24319V7.07652C0.041626 7.90569 0.370793 8.69986 0.956626 9.28652C1.54329 9.87236 2.33746 10.2015 3.16663 10.2015H6.13913C8.45579 10.2015 10.67 11.1607 12.255 12.8515C12.5041 13.1174 12.8908 13.204 13.23 13.0699C13.5691 12.9357 13.7916 12.6082 13.7916 12.244C13.7916 10.0774 13.7916 3.24236 13.7916 1.07569Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3333 6.03516H16.0833C15.7383 6.03516 15.4583 6.31516 15.4583 6.66016C15.4583 7.00516 15.7383 7.28516 16.0833 7.28516H17.3333C17.6783 7.28516 17.9583 7.00516 17.9583 6.66016C17.9583 6.31516 17.6783 6.03516 17.3333 6.03516Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9908 9.99342L15.875 10.8776C16.1192 11.1209 16.515 11.1209 16.7592 10.8776C17.0025 10.6334 17.0025 10.2376 16.7592 9.99342L15.875 9.10926C15.6309 8.86592 15.235 8.86592 14.9908 9.10926C14.7475 9.35342 14.7475 9.74926 14.9908 9.99342Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.875 4.2106L16.7592 3.32643C17.0025 3.08227 17.0025 2.68643 16.7592 2.44227C16.515 2.19893 16.1192 2.19893 15.875 2.44227L14.9908 3.32643C14.7475 3.5706 14.7475 3.96643 14.9908 4.2106C15.235 4.45393 15.6309 4.45393 15.875 4.2106Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.70496 11.0078L3.26829 14.4111C3.38412 15.1153 3.99329 15.632 4.70662 15.632H6.65912C7.01996 15.632 7.35579 15.4453 7.54496 15.1378C7.73496 14.8311 7.75246 14.447 7.59079 14.1245L7.10079 13.1436C7.09329 13.1295 7.08829 13.1153 7.08412 13.1003L6.57746 11.047C6.43162 11.0386 2.85746 11.0253 2.70496 11.0078Z"
      fill="white"
    />
  </svg>
);
export const Bell = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99999 0.400391C7.09044 0.400391 5.25909 1.15896 3.90883 2.50922C2.55856 3.85948 1.79999 5.69083 1.79999 7.60039V11.9036L0.951595 12.752C0.783823 12.9198 0.669575 13.1336 0.623294 13.3664C0.577013 13.5991 0.600777 13.8403 0.691581 14.0596C0.782385 14.2788 0.936152 14.4662 1.13344 14.5981C1.33074 14.7299 1.56269 14.8003 1.79999 14.8004H16.2C16.4373 14.8003 16.6693 14.7299 16.8665 14.5981C17.0638 14.4662 17.2176 14.2788 17.3084 14.0596C17.3992 13.8403 17.423 13.5991 17.3767 13.3664C17.3304 13.1336 17.2162 12.9198 17.0484 12.752L16.2 11.9036V7.60039C16.2 5.69083 15.4414 3.85948 14.0912 2.50922C12.7409 1.15896 10.9096 0.400391 8.99999 0.400391ZM8.99999 19.6004C8.04521 19.6004 7.12954 19.2211 6.45441 18.546C5.77928 17.8708 5.39999 16.9552 5.39999 16.0004H12.6C12.6 16.9552 12.2207 17.8708 11.5456 18.546C10.8704 19.2211 9.95477 19.6004 8.99999 19.6004Z"
      fill="#6B7280"
    />
  </svg>
  // <svg width="18" height="20" stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" ><path d="M440.08 341.31c-1.66-2-3.29-4-4.89-5.93-22-26.61-35.31-42.67-35.31-118 0-39-9.33-71-27.72-95-13.56-17.73-31.89-31.18-56.05-41.12a3 3 0 01-.82-.67C306.6 51.49 282.82 32 256 32s-50.59 19.49-59.28 48.56a3.13 3.13 0 01-.81.65c-56.38 23.21-83.78 67.74-83.78 136.14 0 75.36-13.29 91.42-35.31 118-1.6 1.93-3.23 3.89-4.89 5.93a35.16 35.16 0 00-4.65 37.62c6.17 13 19.32 21.07 34.33 21.07H410.5c14.94 0 28-8.06 34.19-21a35.17 35.17 0 00-4.61-37.66zM256 480a80.06 80.06 0 0070.44-42.13 4 4 0 00-3.54-5.87H189.12a4 4 0 00-3.55 5.87A80.06 80.06 0 00256 480z"></path></svg>
);
export const DotsIcon = () => (
  <svg
    width="5"
    height="16"
    viewBox="0 0 5 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 4C3.6 4 4.5 3.1 4.5 2C4.5 0.9 3.6 0 2.5 0C1.4 0 0.5 0.9 0.5 2C0.5 3.1 1.4 4 2.5 4ZM2.5 6C1.4 6 0.5 6.9 0.5 8C0.5 9.1 1.4 10 2.5 10C3.6 10 4.5 9.1 4.5 8C4.5 6.9 3.6 6 2.5 6ZM2.5 12C1.4 12 0.5 12.9 0.5 14C0.5 15.1 1.4 16 2.5 16C3.6 16 4.5 15.1 4.5 14C4.5 12.9 3.6 12 2.5 12Z"
      fill="#6B7280"
    />
  </svg>
);
export const CancleIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7228 16L16.5 14.2227L10.2772 7.99946L16.5 1.7773L14.7228 9.53674e-07L8.5 6.22216L2.27718 9.53674e-07L0.5 1.7773L6.72282 7.99946L0.5 14.2227L2.27718 16L8.5 9.77676L14.7228 16Z"
      fill="white"
    />
  </svg>
);
export const PlusIcon = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 0C6.81826 0 7.12348 0.126428 7.34853 0.351472C7.57357 0.576516 7.7 0.88174 7.7 1.2V4.8H11.3C11.6183 4.8 11.9235 4.92643 12.1485 5.15147C12.3736 5.37652 12.5 5.68174 12.5 6C12.5 6.31826 12.3736 6.62348 12.1485 6.84853C11.9235 7.07357 11.6183 7.2 11.3 7.2H7.7V10.8C7.7 11.1183 7.57357 11.4235 7.34853 11.6485C7.12348 11.8736 6.81826 12 6.5 12C6.18174 12 5.87652 11.8736 5.65147 11.6485C5.42643 11.4235 5.3 11.1183 5.3 10.8V7.2H1.7C1.38174 7.2 1.07652 7.07357 0.851472 6.84853C0.626428 6.62348 0.5 6.31826 0.5 6C0.5 5.68174 0.626428 5.37652 0.851472 5.15147C1.07652 4.92643 1.38174 4.8 1.7 4.8H5.3V1.2C5.3 0.88174 5.42643 0.576516 5.65147 0.351472C5.87652 0.126428 6.18174 0 6.5 0Z"
      fill="white"
    />
  </svg>
);
export const UploadIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill="#F68C3D" />
    <path d="M10 4.8125V15.1884" stroke="white" strokeWidth="3" />
    <path d="M5.30615 10L14.6939 10" stroke="white" strokeWidth="3" />
  </svg>
);
export const LeftIcon = () => (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 28L16.9675 25.5325L7.2025 15.75L28.5 15.75L28.5 12.25L7.2025 12.25L16.9675 2.4675L14.5 0L0.5 14L14.5 28Z"
      fill="black"
    />
  </svg>
);
export const PlusBlackIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0C6.31826 0 6.62348 0.126428 6.84853 0.351472C7.07357 0.576516 7.2 0.88174 7.2 1.2V4.8H10.8C11.1183 4.8 11.4235 4.92643 11.6485 5.15147C11.8736 5.37652 12 5.68174 12 6C12 6.31826 11.8736 6.62348 11.6485 6.84853C11.4235 7.07357 11.1183 7.2 10.8 7.2H7.2V10.8C7.2 11.1183 7.07357 11.4235 6.84853 11.6485C6.62348 11.8736 6.31826 12 6 12C5.68174 12 5.37652 11.8736 5.15147 11.6485C4.92643 11.4235 4.8 11.1183 4.8 10.8V7.2H1.2C0.88174 7.2 0.576516 7.07357 0.351472 6.84853C0.126428 6.62348 0 6.31826 0 6C0 5.68174 0.126428 5.37652 0.351472 5.15147C0.576516 4.92643 0.88174 4.8 1.2 4.8H4.8V1.2C4.8 0.88174 4.92643 0.576516 5.15147 0.351472C5.37652 0.126428 5.68174 0 6 0Z"
      fill="#434343"
    />
  </svg>
);
export const DeleteIcon = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.25 2H9.5V1.5C9.5 0.672906 8.82709 0 8 0H6C5.17291 0 4.5 0.672906 4.5 1.5V2H1.75C1.06075 2 0.5 2.56075 0.5 3.25V5C0.5 5.27612 0.723875 5.5 1 5.5H1.27325L1.70522 14.5713C1.74338 15.3725 2.4015 16 3.2035 16H10.7965C11.5985 16 12.2567 15.3725 12.2948 14.5713L12.7268 5.5H13C13.2761 5.5 13.5 5.27612 13.5 5V3.25C13.5 2.56075 12.9392 2 12.25 2ZM5.5 1.5C5.5 1.22431 5.72431 1 6 1H8C8.27569 1 8.5 1.22431 8.5 1.5V2H5.5V1.5ZM1.5 3.25C1.5 3.11216 1.61216 3 1.75 3H12.25C12.3878 3 12.5 3.11216 12.5 3.25V4.5C12.3459 4.5 2.13853 4.5 1.5 4.5V3.25ZM11.2959 14.5238C11.2832 14.7908 11.0638 15 10.7965 15H3.2035C2.93616 15 2.71678 14.7908 2.70409 14.5238L2.27437 5.5H11.7256L11.2959 14.5238Z"
      fill="#939393"
    />
    <path
      d="M7 14C7.27613 14 7.5 13.7761 7.5 13.5V7C7.5 6.72387 7.27613 6.5 7 6.5C6.72387 6.5 6.5 6.72387 6.5 7V13.5C6.5 13.7761 6.72384 14 7 14Z"
      fill="#939393"
    />
    <path
      d="M9.5 14C9.77613 14 10 13.7761 10 13.5V7C10 6.72387 9.77613 6.5 9.5 6.5C9.22387 6.5 9 6.72387 9 7V13.5C9 13.7761 9.22384 14 9.5 14Z"
      fill="#939393"
    />
    <path
      d="M4.5 14C4.77613 14 5 13.7761 5 13.5V7C5 6.72387 4.77613 6.5 4.5 6.5C4.22387 6.5 4 6.72387 4 7V13.5C4 13.7761 4.22384 14 4.5 14Z"
      fill="#939393"
    />
  </svg>
);
export const BottomIcon = () => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.46824 6.85848L11.8083 1.51833C11.9319 1.39482 12 1.22994 12 1.05414C12 0.878334 11.9319 0.713458 11.8083 0.589947L11.4151 0.196681C11.1589 -0.0592189 10.7425 -0.0592189 10.4867 0.196681L6.00249 4.68094L1.51326 0.191706C1.38965 0.0681946 1.22487 0 1.04916 0C0.873261 0 0.708482 0.0681946 0.584775 0.191706L0.191706 0.584971C0.0680971 0.70858 0 0.873359 0 1.04916C0 1.22497 0.0680971 1.38984 0.191706 1.51335L5.53664 6.85848C5.66064 6.98229 5.8262 7.05028 6.00219 7.04989C6.17888 7.05028 6.34434 6.98229 6.46824 6.85848Z"
      fill="black"
    />
  </svg>
);
export const PlusCircleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill="#F68C3D" />
    <path d="M10 4.8125V15.1884" stroke="white" strokeWidth="3" />
    <path d="M5.30566 10L14.6934 10" stroke="white" strokeWidth="3" />
  </svg>
);
export const MinusIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#D14343" />
    <path d="M3 8H13" stroke="white" strokeWidth="2" />
  </svg>
);
export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M1.81399 0.333984L0.333008 1.81517L5.51869 7.00155L0.333008 12.187L1.81399 13.6682L6.99968 8.48273L12.1854 13.6682L13.6663 12.187L8.48066 7.00155L13.6663 1.81517L12.1854 0.333984L6.99968 5.52037L1.81399 0.333984Z"
      fill="#242424"
    />
  </svg>
);
export const CollapseIcon = () => (
  <svg
    width="13"
    height="8"
    viewBox="0 0 13 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.96824 6.85848L12.3083 1.51833C12.4319 1.39482 12.5 1.22994 12.5 1.05414C12.5 0.878334 12.4319 0.713458 12.3083 0.589947L11.9151 0.196681C11.6589 -0.0592189 11.2425 -0.0592189 10.9867 0.196681L6.50249 4.68094L2.01326 0.191706C1.88965 0.0681946 1.72487 0 1.54916 0C1.37326 0 1.20848 0.0681946 1.08477 0.191706L0.691706 0.584971C0.568097 0.70858 0.5 0.873359 0.5 1.04916C0.5 1.22497 0.568097 1.38984 0.691706 1.51335L6.03664 6.85848C6.16064 6.98229 6.3262 7.05028 6.50219 7.04989C6.67888 7.05028 6.84434 6.98229 6.96824 6.85848Z"
      fill="#00A651"
    />
  </svg>
);
export const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
  >
    <path
      d="M6.42767 6.54453V10.855M6.42767 10.855L4.0569 8.69978M6.42767 10.855L8.79845 8.69978M10.379 14.4471H2.47639C1.60349 14.4471 0.895874 13.8038 0.895874 13.0103V2.95246C0.895874 2.15892 1.60349 1.51562 2.47639 1.51562H6.8906C7.10019 1.51562 7.30119 1.59132 7.44939 1.72604L11.728 5.6157C11.8762 5.75043 11.9595 5.93316 11.9595 6.1237V13.0103C11.9595 13.8038 11.2519 14.4471 10.379 14.4471Z"
      stroke="#18181B"
      strokeWidth="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const CounterIcon = () => (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99968 0C4.22088 0 0.333011 3.88787 0.333011 8.66667C0.331893 10.0043 0.643832 11.3235 1.24388 12.519C1.39121 12.8137 1.69108 13 2.01954 13H15.9789C16.3074 13 16.6081 12.8137 16.7555 12.519C17.3556 11.3235 17.6675 10.0043 17.6663 8.66667C17.6663 3.88787 13.7785 0 8.99968 0ZM15.4217 11.2667H2.57768C2.23902 10.4417 2.0653 9.55838 2.06634 8.66667C2.06634 4.8438 5.17681 1.73333 8.99968 1.73333C12.8225 1.73333 15.933 4.8438 15.933 8.66667C15.9341 9.55838 15.7604 10.4417 15.4217 11.2667Z"
      fill="white"
    />
    <path
      d="M8.07975 7.74721C7.89541 7.86777 7.744 8.03235 7.63913 8.22613C7.53435 8.41992 7.47949 8.63667 7.47949 8.85698C7.47949 9.07728 7.53435 9.29413 7.63913 9.48783C7.744 9.68161 7.89541 9.84619 8.07975 9.96675C8.22543 10.0626 8.38854 10.1288 8.55988 10.1615C8.73113 10.1942 8.90724 10.1929 9.07797 10.1574C9.24871 10.122 9.41077 10.0532 9.5549 9.95505C9.69903 9.85694 9.82244 9.73127 9.91795 9.58541L13.3517 4.35249C13.3545 4.34791 13.3559 4.34267 13.3559 4.33732C13.3559 4.33198 13.3545 4.32674 13.3517 4.32215C13.3476 4.3159 13.3413 4.3115 13.3339 4.30988C13.3266 4.30827 13.319 4.30956 13.3127 4.31349L8.07975 7.74721Z"
      fill="white"
    />
  </svg>
);

export const rightArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.29279 14.707C7.10532 14.5195 7 14.2652 7 14C7 13.7349 7.10532 13.4806 7.29279 13.293L10.5858 10L7.29279 6.70704C7.11063 6.51844 7.00983 6.26584 7.01211 6.00364C7.01439 5.74144 7.11956 5.49063 7.30497 5.30522C7.49038 5.11981 7.74119 5.01465 8.00339 5.01237C8.26558 5.01009 8.51818 5.11088 8.70679 5.29304L12.7068 9.29304C12.8943 9.48057 12.9996 9.73488 12.9996 10C12.9996 10.2652 12.8943 10.5195 12.7068 10.707L8.70679 14.707C8.51926 14.8945 8.26495 14.9998 7.99979 14.9998C7.73462 14.9998 7.48031 14.8945 7.29279 14.707Z"
      fill="#243639"
    />
  </svg>
);

export const LeftArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.29279 14.707C7.10532 14.5195 7 14.2652 7 14C7 13.7349 7.10532 13.4806 7.29279 13.293L10.5858 10L7.29279 6.70704C7.11063 6.51844 7.00983 6.26584 7.01211 6.00364C7.01439 5.74144 7.11956 5.49063 7.30497 5.30522C7.49038 5.11981 7.74119 5.01465 8.00339 5.01237C8.26558 5.01009 8.51818 5.11088 8.70679 5.29304L12.7068 9.29304C12.8943 9.48057 12.9996 9.73488 12.9996 10C12.9996 10.2652 12.8943 10.5195 12.7068 10.707L8.70679 14.707C8.51926 14.8945 8.26495 14.9998 7.99979 14.9998C7.73462 14.9998 7.48031 14.8945 7.29279 14.707Z"
      fill="#243639"
    />
  </svg>
);

export const Counter = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
  >
    <path
      d="M8.99968 0C4.22088 0 0.333011 3.88787 0.333011 8.66667C0.331893 10.0043 0.643832 11.3235 1.24388 12.519C1.39121 12.8137 1.69108 13 2.01954 13H15.9789C16.3074 13 16.6081 12.8137 16.7555 12.519C17.3556 11.3235 17.6675 10.0043 17.6663 8.66667C17.6663 3.88787 13.7785 0 8.99968 0ZM15.4217 11.2667H2.57768C2.23902 10.4417 2.0653 9.55838 2.06634 8.66667C2.06634 4.8438 5.17681 1.73333 8.99968 1.73333C12.8225 1.73333 15.933 4.8438 15.933 8.66667C15.9341 9.55838 15.7604 10.4417 15.4217 11.2667Z"
      fill="black"
    />
    <path
      d="M8.07975 7.74721C7.89541 7.86777 7.744 8.03235 7.63913 8.22613C7.53435 8.41992 7.47949 8.63667 7.47949 8.85698C7.47949 9.07728 7.53435 9.29413 7.63913 9.48783C7.744 9.68161 7.89541 9.84619 8.07975 9.96675C8.22543 10.0626 8.38854 10.1288 8.55988 10.1615C8.73113 10.1942 8.90724 10.1929 9.07797 10.1574C9.24871 10.122 9.41077 10.0532 9.5549 9.95505C9.69903 9.85694 9.82244 9.73127 9.91795 9.58541L13.3517 4.35249C13.3545 4.34791 13.3559 4.34267 13.3559 4.33732C13.3559 4.33198 13.3545 4.32674 13.3517 4.32215C13.3476 4.3159 13.3413 4.3115 13.3339 4.30988C13.3266 4.30827 13.319 4.30956 13.3127 4.31349L8.07975 7.74721Z"
      fill="black"
    />
  </svg>
);

export const SendIcon = () => (
  <svg width="78" height="79" viewBox="0 0 78 79" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="78" height="79" fill="#989898" />
    <g id="Location request sent">
      <rect width="1920" height="1142" transform="translate(-921 -393)" fill="black" fill-opacity="0.45" />
      <g id="Gift Code">
        <rect x="-250.5" y="-73.5" width="579" height="503" rx="10" fill="white" />
        <g id="Frame 5966">
          <g id="Frame 5989">
            <g id="Frame 5990">
              <g id="sent 1" clip-path="url(#clip0_5758_39911)">
                <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M59.6555 65.4758L35.6891 48.683L78 13.5242L19.8883 39.3781L0 28.5827L78 13.5242L59.6555 65.4758ZM30.8496 47.0988L77.2762 13.9651L22.069 43.0024L24.4512 62.123L30.1877 47.9734C30.3273 47.6282 30.5561 47.3262 30.8505 47.0983L30.8496 47.0988ZM28.3725 63.6585L39.105 56.2194L33.092 52.0071L28.3725 63.6585Z" fill="url(#paint0_linear_5758_39911)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <linearGradient id="paint0_linear_5758_39911" x1="21.2105" y1="59.9549" x2="60.2623" y2="1.37856" gradientUnits="userSpaceOnUse">
        <stop stop-color="#E37400" />
        <stop offset="1" stop-color="#F68C3D" />
      </linearGradient>
      <clipPath id="clip0_5758_39911">
        <rect width="78" height="78" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
export const AlertIcon = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.4399 3.16668C11.2385 2.83228 10.9541 2.55564 10.6142 2.36359C10.2744 2.17154 9.89065 2.07062 9.5003 2.07062C9.10994 2.07062 8.72621 2.17154 8.38637 2.36359C8.04652 2.55564 7.7621 2.83228 7.56071 3.16668L1.32238 13.3554C1.11319 13.6998 0.999347 14.0936 0.992514 14.4965C0.985681 14.8994 1.08611 15.2968 1.28349 15.6481C1.48088 15.9993 1.76813 16.2918 2.1158 16.4955C2.46346 16.6991 2.85903 16.8067 3.26196 16.8071H15.7386C16.1416 16.8067 16.5371 16.6991 16.8848 16.4955C17.2325 16.2918 17.5197 15.9993 17.7171 15.6481C17.9145 15.2968 18.0149 14.8994 18.0081 14.4965C18.0012 14.0936 17.8874 13.6998 17.6782 13.3554L11.4399 3.16668Z" fill="#FF3B30" />
    <path d="M9.50098 11.6771C9.34414 11.675 9.19431 11.6118 9.0834 11.5009C8.97249 11.39 8.90928 11.2402 8.90723 11.0833V7.52084C8.90723 7.36337 8.96978 7.21235 9.08113 7.101C9.19248 6.98965 9.3435 6.92709 9.50098 6.92709C9.65845 6.92709 9.80947 6.98965 9.92082 7.101C10.0322 7.21235 10.0947 7.36337 10.0947 7.52084V11.0833C10.0927 11.2402 10.0295 11.39 9.91855 11.5009C9.80765 11.6118 9.65781 11.675 9.50098 11.6771Z" fill="white" />
    <path d="M9.50065 13.8542C9.93788 13.8542 10.2923 13.4997 10.2923 13.0625C10.2923 12.6253 9.93788 12.2708 9.50065 12.2708C9.06343 12.2708 8.70898 12.6253 8.70898 13.0625C8.70898 13.4997 9.06343 13.8542 9.50065 13.8542Z" fill="white" />
  </svg>
);

export const DownArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.62432 11.8113L15.7444 4.6911C15.9092 4.52641 16 4.30658 16 4.07217C16 3.83777 15.9092 3.61793 15.7444 3.45325L15.2202 2.9289C14.8786 2.5877 14.3234 2.5877 13.9823 2.9289L8.00332 8.90791L2.01768 2.92226C1.85286 2.75758 1.63316 2.66666 1.39888 2.66666C1.16435 2.66666 0.944643 2.75758 0.779701 2.92226L0.255608 3.44662C0.0907965 3.61143 9.53674e-07 3.83114 9.53674e-07 4.06554C9.53674e-07 4.29994 0.0907965 4.51978 0.255608 4.68446L7.38218 11.8113C7.54752 11.9764 7.76826 12.067 8.00293 12.0665C8.2385 12.067 8.45912 11.9764 8.62432 11.8113Z" fill="#242424" />
  </svg>
);
export const VectorIcon = () => (
  <svg width="78" height="53" viewBox="0 0 78 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M59.6555 52.4758L35.6891 35.683L78 0.52417L19.8883 26.3781L0 15.5827L78 0.52417L59.6555 52.4758ZM30.8496 34.0988L77.2762 0.965053L22.069 30.0024L24.4512 49.123L30.1877 34.9734C30.3273 34.6282 30.5561 34.3262 30.8505 34.0983L30.8496 34.0988ZM28.3725 50.6585L39.105 43.2194L33.092 39.0071L28.3725 50.6585Z" fill="url(#paint0_linear_7895_24320)"/>
  </svg>
)
export const Download = () => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 15C0.5 14.4477 0.947715 14 1.5 14H13.5C14.0523 14 14.5 14.4477 14.5 15C14.5 15.5523 14.0523 16 13.5 16H1.5C0.947715 16 0.5 15.5523 0.5 15ZM3.79289 7.29289C4.18342 6.90237 4.81658 6.90237 5.20711 7.29289L6.5 8.58579L6.5 1C6.5 0.447716 6.94771 2.41411e-08 7.5 0C8.05228 -2.41411e-08 8.5 0.447715 8.5 1L8.5 8.58579L9.79289 7.29289C10.1834 6.90237 10.8166 6.90237 11.2071 7.29289C11.5976 7.68342 11.5976 8.31658 11.2071 8.70711L8.20711 11.7071C8.01957 11.8946 7.76522 12 7.5 12C7.23478 12 6.98043 11.8946 6.79289 11.7071L3.79289 8.70711C3.40237 8.31658 3.40237 7.68342 3.79289 7.29289Z" fill="#007AFF"/>
  </svg>
)
export const AttachIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.498 1.37297L8.43292 5.43805C8.42507 5.44586 8.42019 5.45535 8.41237 5.46324C9.41382 5.31738 10.4426 5.41738 11.3963 5.78926L14.1553 3.03027C15.0693 2.11625 16.5558 2.11625 17.4698 3.03027C18.3839 3.94422 18.3839 5.43082 17.4698 6.34476C17.314 6.5007 13.1697 10.645 13.4048 10.4098C12.4835 11.3312 10.9721 11.2918 10.0902 10.4098C9.63343 9.95308 8.88976 9.95308 8.43292 10.4098L7.72144 11.1213C7.91878 11.4566 8.14503 11.7793 8.43292 12.0672C10.1689 13.8031 13.1569 13.9418 15.0369 12.0877C15.0447 12.0799 15.0542 12.075 15.0621 12.0672L19.1271 8.00211C20.9577 6.17148 20.9577 3.20359 19.1271 1.37297C17.2965 -0.457656 14.3287 -0.457656 12.498 1.37297Z" fill="white"/>
    <path d="M9.61267 14.2019L6.84478 16.9698C5.93083 17.8838 4.44423 17.8838 3.53028 16.9698C2.61626 16.0557 2.61626 14.5692 3.53028 13.6552C3.68614 13.4993 7.83927 9.34621 7.60423 9.58125C8.52548 8.66 10.0369 8.69934 10.9188 9.58125C11.3756 10.0381 12.1193 10.0381 12.5761 9.58125L13.2875 8.86977C13.0902 8.53445 12.864 8.2118 12.5761 7.92399C10.8434 6.19129 7.85759 6.04387 5.97212 7.9034C5.96427 7.91121 5.95481 7.91613 5.94692 7.92399L1.87294 11.998C0.0423926 13.8285 0.0423146 16.7965 1.87294 18.6271C3.70356 20.4577 6.67153 20.4577 8.50208 18.6271L12.576 14.5531C12.5839 14.5453 12.5888 14.5359 12.5966 14.5279C11.5951 14.6738 10.5664 14.5738 9.61267 14.2019Z" fill="white"/>
  </svg>
)
export const ResourcesIcon = () => (
<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.4134 5.44276C14.8076 5.44276 14.2071 5.56374 13.6515 5.79452C12.6039 4.19769 10.8275 3.22659 8.89129 3.22659C7.64313 3.22659 6.45801 3.623 5.46414 4.37296C4.61789 5.01155 3.95914 5.88753 3.57789 6.87089C1.57922 7.02468 0 8.70015 0 10.7376C0 12.6746 1.42746 14.2845 3.28566 14.5706C3.2418 14.2743 3.21883 13.9712 3.21883 13.6628C3.21883 10.2567 5.98988 7.48562 9.39602 7.48562C12.8021 7.48562 15.5732 10.2567 15.5732 13.6628C15.5732 13.9865 15.548 14.3044 15.4998 14.6148C17.9891 14.5685 20 12.5294 20 10.0293C20 7.50027 17.9425 5.44276 15.4134 5.44276Z" fill="white"/>
  <path d="M9.39601 8.62802C6.64835 8.62802 4.41296 10.8634 4.41296 13.6111C4.41296 16.3587 6.64835 18.5941 9.39601 18.5941C12.1437 18.5941 14.3791 16.3587 14.3791 13.6111C14.3791 10.8634 12.1436 8.62802 9.39601 8.62802ZM10.9339 14.7038L9.81027 15.8274C9.7966 15.8411 9.78218 15.8541 9.76718 15.8664C9.7605 15.8719 9.75343 15.8767 9.7466 15.8818C9.7382 15.8881 9.72996 15.8946 9.72117 15.9004C9.71285 15.906 9.70417 15.9108 9.69562 15.916C9.68777 15.9206 9.68007 15.9256 9.67199 15.9299C9.66324 15.9346 9.65425 15.9385 9.64535 15.9427C9.63695 15.9467 9.62867 15.9509 9.62003 15.9545C9.61132 15.9581 9.60246 15.961 9.59363 15.9642C9.58441 15.9675 9.57531 15.971 9.56589 15.9738C9.55707 15.9765 9.54812 15.9785 9.53921 15.9807C9.52957 15.9831 9.52007 15.9858 9.51027 15.9878C9.50003 15.9898 9.48968 15.991 9.47937 15.9925C9.47078 15.9937 9.4623 15.9954 9.45359 15.9962C9.43437 15.9981 9.41507 15.9992 9.39578 15.9992C9.37648 15.9992 9.35718 15.9981 9.33796 15.9962C9.32925 15.9954 9.32078 15.9937 9.31218 15.9925C9.30187 15.991 9.29152 15.9898 9.28128 15.9878C9.27148 15.9858 9.26195 15.9831 9.25234 15.9807C9.24457 15.9788 9.23667 15.9773 9.22894 15.975C9.22785 15.9747 9.22675 15.9742 9.22566 15.9739C9.21628 15.971 9.20722 15.9675 9.198 15.9642C9.18914 15.9611 9.18023 15.9581 9.17148 15.9545C9.16292 15.951 9.15476 15.9469 9.14644 15.9429C9.13742 15.9386 9.12835 15.9347 9.11953 15.9299C9.1116 15.9257 9.10402 15.9208 9.09632 15.9162C9.08765 15.911 9.07882 15.9061 9.07039 15.9004C9.06191 15.8948 9.05398 15.8885 9.04582 15.8824C9.03867 15.877 9.03132 15.872 9.02433 15.8663C9.01011 15.8547 8.99648 15.8423 8.98339 15.8293C8.98277 15.8287 8.98207 15.8282 8.98144 15.8276C8.98136 15.8275 8.98132 15.8274 8.98125 15.8274L7.85773 14.7038C7.62898 14.4751 7.62898 14.1042 7.85773 13.8754C8.08644 13.6467 8.45738 13.6467 8.68613 13.8754L8.80984 13.9992V11.8089C8.80984 11.4854 9.0721 11.2231 9.39562 11.2231C9.71914 11.2231 9.9814 11.4854 9.9814 11.8089V13.9992L10.1051 13.8755C10.3338 13.6467 10.7048 13.6467 10.9335 13.8755C11.1626 14.1042 11.1626 14.4751 10.9339 14.7038Z" fill="white"/>
</svg>
)